<template>
    <div class="compare-item">
        <div class="compare-item__val1">
            <div class="compare-item__val-pic" :style="{width: getWidth(item.val[0], item.val[1]) + '%', background: color(item.val[0], item.val[1], item.id)}"></div>
            <div class="compare-item__val-wrapper" :style="{ background: color(item.val[0], item.val[1], item.id)}">
                {{item.val[0]}}
            </div>

        </div>
        <div class="compare-item__name">{{$t(item.t)}}</div>
        <div class="compare-item__val2">
            <div class="compare-item__val-wrapper" :style="{ background: color(item.val[1], item.val[0], item.id)}">
                {{item.val[1]}}
            </div>
            <div class="compare-item__val-pic" :style="{width: getWidth(item.val[1], item.val[0]) + '%', background: color(item.val[1], item.val[0], item.id)}"></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "CompareItem",
        props: ['item'],
        methods: {
            getWidth(val1 = 0 , val2 = 0) {
                if(val1.toString().includes('hrs')){
                    val1 = this.parseHrs(val1);
                    val2 = this.parseHrs(val2);
                }
                const v1 = parseFloat(val1)
                const v2 = parseFloat(val2)
                if(v1 === 0) return 0;
                if(v1 >= v2) return 100;
                return (v1 * 100) / v2;
            },
            parseHrs(val){
                return val.match(/[0-9]*:[0-9]*/)[0].split(':').join('.');
            },
            color(val1=0, val2=0, type) {
                const isReverse = [4, 5, 6, 7].includes(type);
                if(val1.toString().includes('hrs')){
                    val1 = this.parseHrs(val1);
                    val2 = this.parseHrs(val2);
                }
                const v1 = isReverse ? parseFloat(val2) : parseFloat(val1);
                const v2 = isReverse ? parseFloat(val1) : parseFloat(val2);
                if( v1 >= v2) return 'rgba(0, 255, 22, 0.4)';
                return 'rgba(255, 0, 26, 0.4)';
            },
        }
    }
</script>
